import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import BookCard from '../components/BookCard';
import { getBooksApi } from '../utils/api';

const GENRES = ['Fiction','Mystery','Romance','Sci-Fi','Fantasy','Thriller','Self-Help','Biography'];

export default function Home() {
  const [books, setBooks] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    getBooksApi({ limit:6, sort:'newest' })
      .then(({ data }) => setBooks(data.books))
      .catch(console.error)
      .finally(() => setLoading(false));
  }, []);

  return (
    <div>
      {/* ── Hero ───────────────────────────────── */}
      <section style={{
        minHeight:'92vh', display:'flex', alignItems:'center',
        background:'linear-gradient(160deg, #0f0e17 0%, #1a0a30 55%, #0f0e17 100%)',
        position:'relative', overflow:'hidden',
      }}>
        {/* Decorative glows */}
        <div style={{ position:'absolute', top:'15%', right:'8%', width:480, height:480, background:'radial-gradient(circle, rgba(232,197,71,0.08) 0%, transparent 70%)', pointerEvents:'none' }} />
        <div style={{ position:'absolute', bottom:'10%', left:'5%', width:320, height:320, background:'radial-gradient(circle, rgba(229,49,112,0.07) 0%, transparent 70%)', pointerEvents:'none' }} />

        <div className="container fade-up" style={{ position:'relative', zIndex:1 }}>
          <p style={{ color:'var(--gold)', fontWeight:700, fontSize:'0.78rem', letterSpacing:'0.2em', textTransform:'uppercase', marginBottom:24 }}>
            ✦ &nbsp;Welcome to BookPub
          </p>
          <h1 style={{ fontFamily:'var(--font-d)', fontSize:'clamp(3rem,7vw,5.5rem)', fontWeight:300, lineHeight:1.08, color:'var(--text)', maxWidth:700, marginBottom:28 }}>
            Stories that<br/>
            <em style={{ fontStyle:'italic', color:'var(--gold)' }}>refuse to leave</em><br/>
            your mind.
          </h1>
          <p style={{ color:'var(--text2)', fontSize:'1.05rem', maxWidth:480, lineHeight:1.75, marginBottom:44 }}>
            Discover exclusive books and weekly chapters. Read free previews, unlock full stories, support your favourite author directly.
          </p>
          <div style={{ display:'flex', gap:16, flexWrap:'wrap', marginBottom:72 }}>
            <Link to="/books" className="btn btn-gold btn-lg">Explore Library</Link>
            <Link to="/register" className="btn btn-ghost btn-lg">Start Free</Link>
          </div>

          {/* Stats */}
          <div style={{ display:'flex', gap:0, alignItems:'center', flexWrap:'wrap' }}>
            {[['Weekly','New Chapters'], ['Free','Preview Access'], ['Direct','Author Support']].map(([a,b], i) => (
              <React.Fragment key={i}>
                {i > 0 && <div style={{ width:1, height:32, background:'var(--border2)', margin:'0 28px' }} />}
                <div style={{ display:'flex', flexDirection:'column', gap:2 }}>
                  <strong style={{ fontSize:'0.95rem', color:'var(--text)', letterSpacing:'-0.01em' }}>{a}</strong>
                  <span style={{ fontSize:'0.78rem', color:'var(--text3)', letterSpacing:'0.06em', textTransform:'uppercase' }}>{b}</span>
                </div>
              </React.Fragment>
            ))}
          </div>
        </div>
      </section>

      {/* ── Genre strip ────────────────────────── */}
      <section style={{ background:'var(--bg2)', borderTop:'1px solid var(--border)', borderBottom:'1px solid var(--border)', padding:'18px 0' }}>
        <div className="container">
          <div style={{ display:'flex', gap:10, flexWrap:'wrap', alignItems:'center' }}>
            <span style={{ color:'var(--text3)', fontSize:'0.75rem', fontWeight:700, letterSpacing:'0.1em', textTransform:'uppercase', marginRight:6 }}>Browse by</span>
            {GENRES.map(g => (
              <Link key={g} to={`/books?genre=${g}`} style={{
                padding:'6px 16px', border:'1px solid var(--border2)', borderRadius:20,
                color:'var(--text2)', fontSize:'0.8rem', fontWeight:700, textTransform:'uppercase', letterSpacing:'0.06em',
                transition:'all 0.2s', textDecoration:'none',
              }}
              onMouseEnter={e=>{ e.currentTarget.style.borderColor='var(--gold)'; e.currentTarget.style.color='var(--gold)'; }}
              onMouseLeave={e=>{ e.currentTarget.style.borderColor='var(--border2)'; e.currentTarget.style.color='var(--text2)'; }}
              >{g}</Link>
            ))}
          </div>
        </div>
      </section>

      {/* ── Latest Releases ────────────────────── */}
      <section style={{ padding:'80px 0' }}>
        <div className="container">
          <div style={{ display:'flex', justifyContent:'space-between', alignItems:'flex-end', marginBottom:40 }}>
            <div>
              <h2 style={{ fontFamily:'var(--font-d)', fontSize:'2.4rem', fontWeight:600, color:'var(--text)', marginBottom:6 }}>Latest Releases</h2>
              <p style={{ color:'var(--text3)', fontSize:'0.88rem' }}>Fresh stories added every week</p>
            </div>
            <Link to="/books" className="btn btn-ghost btn-sm">View all →</Link>
          </div>

          {loading ? (
              <div className="spinner" />
            ) : books?.length === 0 ? (
              <div style={{ textAlign:'center', padding:'60px 0', color:'var(--text3)' }}>
                No books yet — check back soon!
              </div>
            ) : (
              <div className="grid-books">
                {books?.map(b => <BookCard key={b._id} book={b} />)}
              </div>
            )}
        </div>
      </section>

      {/* ── CTA ───────────────────────────────── */}
      <section style={{ background:'linear-gradient(135deg, #1a0a30, #0f0e17 80%)', borderTop:'1px solid var(--border)', padding:'80px 0' }}>
        <div className="container" style={{ textAlign:'center', display:'flex', flexDirection:'column', alignItems:'center', gap:20 }}>
          <h2 style={{ fontFamily:'var(--font-d)', fontSize:'2.6rem', fontWeight:300, color:'var(--text)' }}>
            New chapters, <em style={{ color:'var(--gold)', fontStyle:'italic' }}>every week.</em>
          </h2>
          <p style={{ color:'var(--text2)', maxWidth:460, fontSize:'0.95rem', lineHeight:1.75 }}>
            Create a free account to track your reading, save books, and never miss a new release.
          </p>
          <Link to="/register" className="btn btn-gold btn-lg" style={{ marginTop:8 }}>Create Free Account</Link>
        </div>
      </section>
    </div>
  );
}
